import PropTypes from 'prop-types'
import Tags from '@/components/Tags/Tags'
import {
  CheckDoubleOutlined,
  CheckHistoryOutlined,
  ClockSolid,
  XCircleSolid,
} from '@/assets/svgs/status'
import { resolveStatusTag } from '../constants'

// Role name -> Tailwind classes. Same four roles pitstop's DS tag variants
// cover, so a status resolved there lands on the same colour here.
const VARIANT_CLASS = {
  neutral: 'bg-grey-95 text-grey-50 [&_svg_path]:fill-grey-50',
  warning: 'bg-yellow-95 text-yellow-50 [&_svg_path]:fill-yellow-50',
  success: 'bg-green-95 text-green-50 [&_svg_path]:fill-green-50',
  critical: 'bg-red-95 text-red-50 [&_svg_path]:fill-red-50',
}

const ICONS = {
  'check-double': <CheckDoubleOutlined />,
  history: <CheckHistoryOutlined />,
  'x-circle': <XCircleSolid />,
  clock: <ClockSolid />,
}

/**
 * A submittal's status as a tag, worded for the data element's own workflow.
 *
 * `secondaryApproval` comes from the data element record: `required` says the
 * element has a second approver, `label` names them. Without it a status reads
 * with its single-stage wording, which is correct for EMS.
 *
 * An unrecognised code renders as plain text rather than a tag, so a status the
 * frontend does not know about is visibly unstyled instead of mislabelled.
 */
const SubmittalStatusTag = ({ status, secondaryApproval }) => {
  const tag = resolveStatusTag(status, secondaryApproval)
  if (!tag) return status || '-'

  return (
    <Tags
      dataTestId="status-tag"
      label={tag.label}
      prefixIcon={ICONS[tag.icon]}
      tagClassName={VARIANT_CLASS[tag.variant]}
    />
  )
}

SubmittalStatusTag.propTypes = {
  status: PropTypes.string,
  secondaryApproval: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
  }),
}

export default SubmittalStatusTag
